import React, { useState } from "react";
import "./index.css";

const CustomTable = ({ data }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  if (!data || !data.rows || data.rows.length === 0) {
    return <div className="customTable">No data available</div>;
  }

  // Find header row (supports both Post and Product field group names)
  const headerRowData = data.rows.find(
    (row) => row.fieldGroupName?.includes("HeaderRow") || row.headerRow
  );

  const headers = headerRowData?.headerRow?.map((h) => h.headerCell) || [];

  // Find content rows (supports both Post and Product field group names)
  const contentRows = data.rows.filter(
    (row) => row.fieldGroupName?.includes("ContentRow") || row.contentRow
  );

  return (
    <div className="customTable">
      {/* Desktop Table */}
      <table className="customTable__table">
        <thead className="customTable__thead">
          <tr className="customTable__headerRow">
            {headers.map((header, idx) => (
              <th key={idx} className="customTable__header">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="customTable__tbody">
          {contentRows.map((row, rowIdx) => {
            const cells = Array.isArray(row.contentRow) ? row.contentRow : [row.contentRow].filter(Boolean);
            return (
              <tr key={rowIdx} className="customTable__row">
                {cells.map((cellObj, cellIdx) => {
                  const cell = cellObj.contentCell;
                  const heading = cell?.cellHeading || "";
                  const headingColor = cell?.cellHeadingColor || "#000000";
                  const content = cell?.cellContent || "";
                  const isEmpty = !heading && !content;

                  return (
                    <td key={cellIdx} className={`customTable__cell ${isEmpty ? "customTable__cell--empty" : ""} ${cellIdx===0 ? " customTable__cell--first" : ""}`}>
                      {heading && <div className={`customTable__cellHeading`} style={{ color: headingColor }}>
                        {heading}
                      </div>}
                      {content && <div className="customTable__cellContent">{content}</div>}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Mobile Tabs */}
      <div className="customTable__mobile">
        <div className="customTable__tabs">
          {contentRows.map((row, rowIdx) => {
            const cells = Array.isArray(row.contentRow) ? row.contentRow : [row.contentRow].filter(Boolean);
            const cityName = cells[0]?.contentCell?.cellHeading || `Row ${rowIdx + 1}`;

            return (
              <button
                key={rowIdx}
                className={`customTable__tab ${selectedTabIndex === rowIdx ? "customTable__tab--active" : ""}`}
                onClick={() => setSelectedTabIndex(rowIdx)}
              >
                {cityName}
              </button>
            );
          })}
        </div>

        {/* Tab Content */}
        {contentRows.length > 0 && (
          <div className="customTable__tabContent">
            {(() => {
              const row = contentRows[selectedTabIndex];
              const cells = Array.isArray(row?.contentRow) ? row.contentRow : [row?.contentRow].filter(Boolean);
              const cityName = cells[0]?.contentCell?.cellHeading || `Row ${selectedTabIndex + 1}`;

              return (
                <div className="customTable__card">
                  <div className="customTable__cardHeader">{cityName}</div>
                  <div className="customTable__cardContent">
                    {cells.map((cellObj, cellIdx) => {
                      const cell = cellObj.contentCell;
                      const heading = cell?.cellHeading || "";
                      const headingColor = cell?.cellHeadingColor || "#000000";
                      const content = cell?.cellContent || "";
                      const isEmpty = !heading && !content;
                      const columnHeader = headers[cellIdx] || "";

                      // Skip the first cell (city name) as it's already shown in cardHeader
                      if (cellIdx === 0) return null;

                      if (isEmpty) return null;

                      return (
                        <div key={cellIdx} className="customTable__cardItem">
                          {columnHeader && (
                            <div className="customTable__cardItemColumnHeader">
                              {columnHeader}
                            </div>
                          )}
                          {heading && (
                            <div className="customTable__cardItemLabel" style={{ color: headingColor }}>
                              {heading}
                            </div>
                          )}
                          {content && <div className="customTable__cardItemValue">{content}</div>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomTable;
